/**
 * The reviewer-facing status chip (queued | checking | checked | reviewing | done | error).
 * See ../../lib/reviewerStatus.ts for the wording/tone; "checking" animates so the
 * reviewer knows the AI pass is mid-flight.
 */
import { reviewerStatusChip } from '../../lib/reviewerStatus';

export function StatusChip({ status }: { status: string }) {
  const meta = reviewerStatusChip(status);
  return (
    <span className={`rstatus rstatus--${meta.tone}${meta.animate ? ' rstatus--animate' : ''}`}>
      <span className="rstatus__dot" aria-hidden="true" />
      {meta.label}
    </span>
  );
}
